module.exports = __webpack_public_path__ + "img/klcx_03.a104dd62.jpg";